export const INITIAL_COMPRESS_QUALITY = 40;
